import { IConfig } from './config';
import { Client } from './LRPProxy';

export const client = new Client(new IConfig(), process.env.REACT_APP_API_URL);
